import React from 'react';
import Badge from '@mui/material/Badge';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

 
const NotificationBell = ({ notificationCount }) => {
  return (
    <Badge
      badgeContent={notificationCount}
      color="primary"
      sx={{
        '& .MuiBadge-badge': {
          fontSize: '0.75rem',
          height: '16px',
          minWidth: '16px',
          color: "white",
          backgroundColor: "#00A0A6",
          transform: 'translate(25%, 140%)',
          border: "1px solid white"
        },
      }}        
    >
      <NotificationsNoneOutlinedIcon fontSize='large' sx={{ color: "black", mt:3 }}>
      </NotificationsNoneOutlinedIcon>
    </Badge>
  );
};
 
export default NotificationBell;